var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "classView" } },
    [
      _c(
        "v-overlay",
        { staticClass: "waitoverlay", attrs: { value: _vm.busy } },
        [
          _c("v-progress-circular", {
            staticClass: "mr-4",
            attrs: { indeterminate: "", size: "64" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("global.loading")) + " ")
        ],
        1
      ),
      _c("v-breadcrumbs", { attrs: { items: _vm.breadcrumbs, divider: "-" } }),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              model: {
                value: _vm.showGenerator,
                callback: function($$v) {
                  _vm.showGenerator = $$v
                },
                expression: "showGenerator"
              }
            },
            [
              _c(
                "shortcode-generator",
                {
                  ref: "generator",
                  attrs: {
                    action: "classShortCode",
                    "class-id": _vm.currentClassID,
                    title: _vm.$t("class.class-code")
                  }
                },
                [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("class.class-code-description")))
                  ]),
                  _c("p", [
                    _c("b", [
                      _vm._v(_vm._s(_vm.$t("class.class-code-warning")))
                    ])
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "6" } }, [
                    _vm._v(" " + _vm._s(_vm.className) + " ")
                  ]),
                  _c(
                    "v-col",
                    { staticClass: "text-end", attrs: { cols: "6" } },
                    [
                      _vm.currentClass
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "blue" },
                              on: { click: _vm.showShortcodeGenerator }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("class.show-class-code")) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.currentClass
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "primary" },
                              on: { click: _vm.showUserSelectDialog }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("class.add-learners")) + " "
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "v-menu",
                        {
                          attrs: { "offset-y": "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          attrs: {
                                            color: "secondary",
                                            dark: "",
                                            width: "1px"
                                          }
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_c("v-icon", {}, [_vm._v(" mdi-menu ")])],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c(
                            "v-list",
                            { staticClass: "pa-0", attrs: { width: "260px" } },
                            [
                              _c(
                                "v-list-item",
                                { staticClass: "pa-0" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        text: true,
                                        color: "black",
                                        block: ""
                                      },
                                      on: { click: _vm.viewStats }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("class.view-stats")) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "pa-0" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        text: true,
                                        color: "black",
                                        block: ""
                                      },
                                      on: { click: _vm.editClass }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("class.edit")) + " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm.currentClass &&
                              _vm.currentClass.enrolmentType !== undefined &&
                                _vm.currentClass.enrolmentType !== "inviteOnly"
                                ? _c(
                                    "v-list-item",
                                    { staticClass: "pa-0" },
                                    [
                                      _vm.currentClass &&
                                      _vm.currentClass.enrolmentType !==
                                        undefined &&
                                        _vm.currentClass.enrolmentType !==
                                          "inviteOnly"
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: true,
                                                color: "black",
                                                block: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.enrolmentLinkVisible = true
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "class.enrolment-link"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-list-item",
                                { staticClass: "pa-0" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        text: true,
                                        color: "black",
                                        block: ""
                                      },
                                      on: { click: _vm.confirmInviteAll }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("class.send-invitations")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm.hasDataSharingPermission
                                ? _c(
                                    "v-list-item",
                                    { staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            text: true,
                                            color: "black",
                                            block: ""
                                          },
                                          on: { click: _vm.viewSettings }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("data-settings")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.hasDataSharingPermission
                                ? _c(
                                    "v-list-item",
                                    { staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            text: true,
                                            color: "black",
                                            block: ""
                                          },
                                          on: { click: _vm.viewExport }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("export-data")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-list-item",
                                { staticClass: "pa-0" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        text: true,
                                        color: "black",
                                        block: ""
                                      },
                                      on: { click: _vm.exportData }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("download-class")) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "pa-0" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        text: true,
                                        color: "black",
                                        block: ""
                                      },
                                      on: { click: _vm.refreshItems }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("class.refresh")) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "div",
                { staticClass: "searchBox" },
                [
                  _c("v-text-field", {
                    staticClass: "limitWidth",
                    attrs: {
                      "append-icon": "mdi-magnify",
                      label: _vm.$t("global.search"),
                      "single-line": "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              ),
              _c("v-data-table", {
                attrs: {
                  filterable: "",
                  headers: _vm.headers.map(function(x) {
                    return Object.assign({}, x, { text: _vm.$t(x.text) })
                  }),
                  items: _vm.items,
                  "item-key": "id",
                  loading: _vm.loading,
                  search: _vm.search,
                  "items-per-page": 30,
                  "footer-props": {
                    "items-per-page-options": [15, 30, 50, 100, -1]
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.code",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        item.code
                          ? _c("div", [_vm._v(" " + _vm._s(item.code) + " ")])
                          : _c(
                              "div",
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.shortCode(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  on
                                                ),
                                                [_vm._v(" mdi-key-outline ")]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("get-quick-code")))
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                      ]
                    }
                  },
                  {
                    key: "item.actions",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          {
                                            staticClass: "mr-2",
                                            attrs: { disabled: _vm.loading },
                                            on: {
                                              click: function($event) {
                                                return _vm.deleteItem(item)
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [_vm._v(" mdi-delete-outline ")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.$t("delete")))])]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          {
                                            staticClass: "mr-2",
                                            on: {
                                              click: function($event) {
                                                return _vm.sendInvite(item)
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [_vm._v(" mdi-email-outline ")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("send-invitations")))
                            ])
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.displayName",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("a", { attrs: { href: _vm.createURL(item) } }, [
                          _vm._v(
                            " " + _vm._s(_vm.getClassLearnerName(item)) + " "
                          )
                        ])
                      ]
                    }
                  },
                  {
                    key: "item.email",
                    fn: function(ref) {
                      var item = ref.item
                      return [_vm._v(" " + _vm._s(item.email) + " ")]
                    }
                  },
                  {
                    key: "item.tag",
                    fn: function(ref) {
                      var item = ref.item
                      return [_vm._v(" " + _vm._s(item.tag) + " ")]
                    }
                  },
                  {
                    key: "item.statusText",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-chip",
                                        _vm._g(
                                          {
                                            staticClass: "status-chip",
                                            class: item.status
                                          },
                                          on
                                        ),
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                width: "150px",
                                                height: "100%"
                                              }
                                            },
                                            [
                                              _c("v-progress-linear", {
                                                staticClass:
                                                  "status-progress-bar",
                                                class: item.status + "-bar",
                                                attrs: {
                                                  value: item.progress,
                                                  height: "100%",
                                                  color: "green",
                                                  "background-color":
                                                    "transparent"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "status-text" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.statusText) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c("div", {
                              domProps: { innerHTML: _vm._s(item.tooltip) }
                            })
                          ]
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.selected,
                  callback: function($$v) {
                    _vm.selected = $$v
                  },
                  expression: "selected"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "700px" },
              model: {
                value: _vm.userSelectDialogVisible,
                callback: function($$v) {
                  _vm.userSelectDialogVisible = $$v
                },
                expression: "userSelectDialogVisible"
              }
            },
            [
              _c("user-selection-dialog", {
                ref: "selectionDialog",
                attrs: { items: _vm.addLearnersList },
                on: {
                  cancel: _vm.cancelUserSelectDialog,
                  save: _vm.saveUserSelectDialog
                }
              })
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              model: {
                value: _vm.dataSettingsWindow,
                callback: function($$v) {
                  _vm.dataSettingsWindow = $$v
                },
                expression: "dataSettingsWindow"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(_vm._s(_vm.$t("data-settings-0")))
                  ]),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-form",
                        { ref: "form" },
                        [
                          _c("v-switch", {
                            attrs: {
                              label: _vm.$t("enable-data-sharing"),
                              inset: ""
                            },
                            model: {
                              value: _vm.dataSharing.enableDataSharing,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.dataSharing,
                                  "enableDataSharing",
                                  $$v
                                )
                              },
                              expression: "dataSharing.enableDataSharing"
                            }
                          }),
                          _c("v-expand-transition", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.dataSharing.enableDataSharing,
                                    expression: "dataSharing.enableDataSharing"
                                  }
                                ]
                              },
                              [
                                _c("v-select", {
                                  attrs: {
                                    label: _vm.$t("agreement-id"),
                                    hint: _vm.$t(
                                      "this-is-a-unique-that-is-provided-to-you-by-bodyswaps"
                                    ),
                                    items: _vm.agreementKeys,
                                    "persistent-hint": ""
                                  },
                                  model: {
                                    value: _vm.dataSharing.agreementID,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSharing,
                                        "agreementID",
                                        $$v
                                      )
                                    },
                                    expression: "dataSharing.agreementID"
                                  }
                                }),
                                _c("v-switch", {
                                  attrs: {
                                    label: _vm.$t("mandatory"),
                                    inset: ""
                                  },
                                  model: {
                                    value: _vm.dataSharing.mandatory,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSharing,
                                        "mandatory",
                                        $$v
                                      )
                                    },
                                    expression: "dataSharing.mandatory"
                                  }
                                }),
                                _c(
                                  "v-expand-transition",
                                  [
                                    _c(
                                      "v-card",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.dataSharing.agreementID,
                                            expression:
                                              "dataSharing.agreementID"
                                          }
                                        ]
                                      },
                                      [
                                        _c(
                                          "v-card-text",
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(_vm.$t("class.settings"))
                                              )
                                            ]),
                                            _c("v-textarea", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "in-app-agreement-text"
                                                ),
                                                readonly: "",
                                                required: false,
                                                "persistent-hint": ""
                                              },
                                              model: {
                                                value: _vm.agreementText,
                                                callback: function($$v) {
                                                  _vm.agreementText = $$v
                                                },
                                                expression: "agreementText"
                                              }
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                rules: _vm.rules.isUrl,
                                                label: _vm.url,
                                                readonly: "",
                                                required: false,
                                                "persistent-hint": ""
                                              },
                                              model: {
                                                value: _vm.agreementUrl,
                                                callback: function($$v) {
                                                  _vm.agreementUrl = $$v
                                                },
                                                expression: "agreementUrl"
                                              }
                                            }),
                                            _c("v-switch", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "anonymise-data-0"
                                                ),
                                                inset: "",
                                                readonly: ""
                                              },
                                              model: {
                                                value: _vm.agreementAnonymise,
                                                callback: function($$v) {
                                                  _vm.agreementAnonymise = $$v
                                                },
                                                expression: "agreementAnonymise"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]),
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "secondary" },
                                  on: { click: _vm.closeSettingsDialog }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("global.cancel")) + " "
                                  )
                                ]
                              ),
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "blue" },
                                  on: { click: _vm.saveSettings }
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              model: {
                value: _vm.showViewExport,
                callback: function($$v) {
                  _vm.showViewExport = $$v
                },
                expression: "showViewExport"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_vm._v(_vm._s(_vm.$t("export-data-0")))]),
                  _c(
                    "v-card-text",
                    [
                      _c("date-range-picker", {
                        attrs: { "text-color": "blacktext" },
                        on: { datesChange: _vm.exportDataDatesChanged }
                      }),
                      _c(
                        "v-card-actions",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "secondary" },
                              on: { click: _vm.cancelExportClassData }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("global.cancel")) + " "
                              )
                            ]
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "blue" },
                              on: { click: _vm.exportClassData }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "700px" },
              model: {
                value: _vm.showDeleteDialog,
                callback: function($$v) {
                  _vm.showDeleteDialog = $$v
                },
                expression: "showDeleteDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("class.remove-dialog.title", [
                          _vm.editedItem.displayName
                        ])
                      )
                    )
                  ]),
                  _c("v-card-text", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("class.remove.confirmtext", [
                          _vm.editedItem.displayName
                        ])
                      )
                    )
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary" },
                          on: { click: _vm.closeDeleteDialog }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "error" },
                          on: { click: _vm.confirmDeleteItem }
                        },
                        [_vm._v(" OK ")]
                      ),
                      _c("v-spacer")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "700px" },
              model: {
                value: _vm.inviteAllDialogVisible,
                callback: function($$v) {
                  _vm.inviteAllDialogVisible = $$v
                },
                expression: "inviteAllDialogVisible"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(_vm._s(_vm.$t("class.send-invitations")))
                  ]),
                  _c("v-card-text", [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("class.send-invite-text"))
                      }
                    })
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary" },
                          on: { click: _vm.cancelInviteAll }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: { click: _vm.inviteNew }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("class.uninvited")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "error" },
                          on: { click: _vm.inviteAll }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("class.everyone")) + " ")]
                      ),
                      _c("v-spacer")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "700px" },
              model: {
                value: _vm.enrolmentLinkVisible,
                callback: function($$v) {
                  _vm.enrolmentLinkVisible = $$v
                },
                expression: "enrolmentLinkVisible"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(_vm._s(_vm.$t("class.enrolment-link")))
                  ]),
                  _c(
                    "v-card-text",
                    [
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("class.enrolment-link-instructions"))
                        )
                      ]),
                      _c(
                        "v-spacer",
                        [
                          _c("link-sharer", {
                            attrs: { link: _vm.enrolmentLink }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function($event) {
                              _vm.enrolmentLinkVisible = false
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.close")) + " ")]
                      ),
                      _c("v-spacer")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { timeout: _vm.timeout },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function(ref) {
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { color: "blue", text: "" },
                        on: {
                          click: function($event) {
                            _vm.snackbar = false
                          }
                        }
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" " + _vm._s(_vm.$t("global.close")) + " ")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [_vm._v(" " + _vm._s(_vm.inviteText) + " ")]
      ),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "700px" },
              model: {
                value: _vm.showClassEditDialog,
                callback: function($$v) {
                  _vm.showClassEditDialog = $$v
                },
                expression: "showClassEditDialog"
              }
            },
            [
              _c("class-edit", {
                attrs: { model: _vm.currentClass, editors: _vm.coaches },
                on: { cancel: _vm.closeClassEditDialog, save: _vm.saveClass }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }